var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex justify-content-between d-none d-lg-flex d-xl-flex d-md-flex col-9"
    },
    [
      _c("div", { staticClass: "border-right text-center px-1 col-2" }, [
        _c("label", [_vm._v("Min.")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-text" }, [
          _vm._v(
            _vm._s(
              _vm.job.minimum_hours ? _vm.job.minimum_hours + "h" : "Not set"
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "border-right col-3" }, [
        _c("label", [_vm._v("Moving Company:")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-text" }, [
          _vm._v(_vm._s(_vm.job.company && _vm.job.company.name))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "border-right col-3" }, [
        _c("label", [_vm._v("Carrier:")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-text" }, [
          _vm._v(_vm._s(_vm.job.carrier && _vm.job.carrier.name))
        ])
      ]),
      _vm._v(" "),
      _vm.$_can("jobs.carrier.assign")
        ? _c("div", { staticClass: "border-right col-3" }, [
            _c("label", [_vm._v("Lead created by:")]),
            _vm._v(" "),
            _c("div", { staticClass: "info-text" }, [
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.job.lead_created_by &&
                        _vm.job.lead_created_by.username
                    ) +
                    "\n      "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [
        _c("label", [_vm._v("Assigned:")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-text" }, [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.job.cluster_user && _vm.job.cluster_user.username) +
                "\n      "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10699133", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10699133","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobMoveInfo.vue
// module id = null
// module chunks = 